import { render, staticRenderFns } from "./GroupClasses.vue?vue&type=template&id=49e89589&scoped=true&"
import script from "./GroupClasses.vue?vue&type=script&lang=js&"
export * from "./GroupClasses.vue?vue&type=script&lang=js&"
import style0 from "./GroupClasses.vue?vue&type=style&index=0&id=49e89589&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e89589",
  null
  
)

export default component.exports